import React from 'react';
import Slider from "react-slick";
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";
import snookerBanner from "../../img/snookerNew.png"
import styles from "./index.module.scss"
const BannerCarousel: React.FC = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <Slider {...settings}>
            <div className={styles.imgWrapper}>
                <img src={"https://cdn.pixabay.com/photo/2019/11/08/09/25/darts-4610861_640.jpg"} alt="Banner 1"/>
            </div>
            <div className={styles.imgWrapper}>
                <img src={"https://www.shutterstock.com/image-photo/table-tennis-banner-260nw-2604580207.jpg"} alt="Banner 2"/>
            </div>
            <div className={styles.imgWrapper}>
                <img src={snookerBanner} alt="Banner 3"/>
            </div>
        </Slider>
    );
};

export default BannerCarousel;